var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skeleton"},_vm._l((_vm.lines),function(line){return _c('div',{key:(line + "-filter-skeleton")})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }